import { checkIfDailyHoursIsSmallerOrEqual } from '../../../../../../../utils/globals/schedule'
import { WCalTurnScheduleDictTY } from '../types'

export const checkIfDailyHoursIsSmallerModalCEWTurn = (mySchedule: { [key: string]: WCalTurnScheduleDictTY }) => {
    let hasError = false
    if (mySchedule) {
        for (const key in mySchedule) {
            for (const WorkingCenterId in mySchedule[key]) {
                let myDaySchedule = mySchedule[key][WorkingCenterId]?.schedule as any
                if (checkIfDailyHoursIsSmallerOrEqual(myDaySchedule).hasError) {
                    hasError = true
                }
            }
        }
    }
    return { hasError }
}